module.exports = __webpack_public_path__ + "img/join_meeting_selected.4788b453.svg";